import React, { useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { IconFieldComponent } from "../fields";
import { RevenueChartComponent } from "../charts";

export default function RevenueCardComponent({ data, formState }) {
  const { t } = useContext(TranslatorContext);

  const years = ["year 2021",
    "year 2020",
    "year 2019",
    "year 2018",
    "year 2017",
    "year 2016",
    "year 2015",];

  return (
    <div className="mc-card">
      <div className="mc-revenue-card-header">
        <h5 className="mc-card-title">{t("Financial Report")}</h5>

        <IconFieldComponent
          icon="bolt"
          classes="w-sm h-sm"
          activeOption="Select Request ID"
          option={data?.family_requests?.map(req => req.rfq_id) || []}

        />



      </div>
      <div className="mc-revenue-card-group">
        <div className="mc-revenue-card-report">
          <i className="material-icons blue">monetization_on</i>
          <h3>
            <span>{t("Incoming Funds")}</span>{data?.financial_report?.totals.incoming || 0}
          </h3>
        </div>
        <div className="mc-revenue-card-report">
          <i className="material-icons purple">layers</i>
          <h3>
            <span>{t("expenses")}</span>{data?.financial_report?.totals.expense || 0}
          </h3>
        </div>
        <div className="mc-revenue-card-report">
          <i className="material-icons green">bookmarks</i>
          <h3>
            <span>{t("Balance")}</span>{data?.financial_report?.totals.balance || 0}
          </h3>
        </div>
      </div>
      <RevenueChartComponent finance={data?.financial_report || {}} />
    </div>
  );
}
